import { RecibopublicoComponent } from './components/recibopublico/recibopublico.component';
import { UsuarioslanderComponent } from './components/usuario/usuarioslander/usuarioslander.component';
import { CrecimientoComponent } from './components/grafico/crecimiento/crecimiento.component';
import { ProyeccionesComponent } from './components/proyecciones/proyecciones.component';
import { HistorialComponent } from './components/historial/historial.component';
import { PoliticasComponent } from './components/politicas/politicas.component';
import { PaypalComponent } from './components/paypal/paypal.component';
import { LoginGuardian } from './components/usuario/login/login-guardian-service';
import { ListadoticketgestorComponent } from './components/listadoticketgestor/listadoticketgestor.component';

import { RegisterComponent } from './components/usuario/register/register.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/usuario/login/login.component';
import { PrincipalComponent } from './components/principal/principal.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LicenciasComponent } from './components/licencias/licencias.component';
import { TablaComponent } from './components/tabla/tabla.component';
import { LandingComponent } from './components/landing/landing.component';
import { PermisosComponent } from './components/usuario/permisos/permisos.component';
import { SidebarlandingComponent } from './components/sidebarlanding/sidebarlanding.component';
import { ContactanosComponent } from './components/contactanos/contactanos.component';
import { SidebargestorComponent } from './components/sidebargestor/sidebargestor.component';
import { GestoresComponent } from './components/gestores/gestores.component';
import { ReciboComponent } from './components/recibo/recibo.component';
import { EmailComponent } from './components/email/email.component';
import { FantasmaComponent } from './components/fantasma/fantasma.component';
import { RedireccionaurlComponent } from './components/redireccionaurl/redireccionaurl.component';
import { PrepagoComponent } from './components/prepago/prepago.component';
import { AgenciasComponent } from './components/agencias/agencias.component';
import { Inventariolote } from './models/inventariolote';
import { InventariolotesComponent } from './components/inventariolotes/inventariolotes.component';
import { BotadminComponent } from './components/botadmin/botadmin.component';
import { GestorprepagoComponent } from './components/gestorprepago/gestorprepago.component';
import { UtileriasComponent } from './components/utilerias/utilerias.component';
import { registerLocaleData } from '@angular/common';




// this.router.navigate(['/externalRedirect', { externalUrl: url }]);
// {path: '' , component: PrincipalComponent },


const routes: Routes = [







  {
    path:'',
    children:[

      
  { path: '', component: RedireccionaurlComponent },

  { path: 'login/login', component: LoginComponent },
  { path: 'login/registrar', component: RegisterComponent },
  { path: 'main', component: SidebarComponent },
  { path: 'obtenerlicencia', component: LicenciasComponent },
  { path: 'contactanos', component: ContactanosComponent },
  { path: 'contactanos', component: ContactanosComponent },
  { path: 'sidebargestores', component: SidebargestorComponent },
  { path: 'recibo', component: ReciboComponent },
  { path: 'email', component: EmailComponent },
  { path: 'paypal', component: PaypalComponent },
  { path: 'politicas', component: PoliticasComponent },
  { path: 'recibopublico', component: RecibopublicoComponent },




  {
    path: 'usuariospendientes', canActivate: [LoginGuardian],
    component: SidebarComponent,
    children: [{
      path: '',
      component: PermisosComponent
    }]
  },

  {
    path: 'inventariolote', canActivate: [LoginGuardian],
    component: SidebarComponent,
    children: [{
      path: '',
      component: InventariolotesComponent
    }]
  },

  {
    path: 'tabla',
    component: SidebarComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: TablaComponent
    }]
  },


  {
    path: 'botadmin',
    component: SidebarComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: BotadminComponent
    }]
  },



  {
    path: 'historial',
    component: SidebarComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: HistorialComponent
    }]
  },


  {
    path: 'graficolineal',
    component: SidebarComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: CrecimientoComponent
    }]
  },

  {
    path: 'utilerias',
    component: SidebarComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: UtileriasComponent
    }]
  },




  {
    path: 'usuariosportfishing',
    component: SidebarComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: UsuarioslanderComponent
    }]
  },




  {
    path: 'gestores',
    component: SidebargestorComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: GestoresComponent
    }]
  },



  {
    path: 'landing',
    component: SidebarlandingComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: LandingComponent
    }]
  },


  {
    path: 'gestoresmenu', canActivate: [LoginGuardian],
    component: SidebarlandingComponent,
    children: [{
      path: '',
      component: AgenciasComponent
    }]
  },


  {
    path: 'ticketgestor',
    component: SidebargestorComponent,
    children: [{
      path: '',
      component: ListadoticketgestorComponent
    }]
  },

  {
    path: 'prepago', canActivate: [LoginGuardian],
    component: SidebarlandingComponent,
    children: [{
      path: '',
      component: PrepagoComponent
    }]
  },

  {
    path: 'fantasma',
    component: SidebargestorComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: FantasmaComponent
    }]
  },

  {
    path: 'listausuarios',

    component: SidebarlandingComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: UsuarioslanderComponent
    }]
  },

  {
    path: 'gestorprepago',
    component: SidebarlandingComponent, canActivate: [LoginGuardian],
    children: [{
      path: '',
      component: GestorprepagoComponent
    }]
  },

 
      
    ]
  }







];

@NgModule({
  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule]
})
export class AppRoutingModule { }
